import React, { useState, memo } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Card';
import { AlertTriangle, AlertCircle, Info, ShieldAlert, Send } from 'lucide-react';
import { Button } from '../Button';
import { toast } from 'sonner';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '../Dialog';
import { Label } from '../Label';
import { Textarea } from '../Textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../Select';
const alerts = [{
  id: 1,
  severity: 'KRITIS',
  title: 'Deepfake audio Presiden beredar di TikTok',
  context: 'Terdeteksi 45 video dengan audio identik, potensi viral tinggi.',
  time: '10 menit lalu',
  icon: AlertTriangle,
  color: 'text-red-500',
  bg: 'bg-red-500/10',
  border: 'border-red-500/30'
}, {
  id: 2,
  severity: 'TINGGI',
  title: 'Operasi tagar terkoordinasi #TolakKebijakanX',
  context: 'Terdeteksi 1.247 akun bot memompa tagar sejak 02:00 WIB.',
  time: '45 menit lalu',
  icon: AlertCircle,
  color: 'text-amber-500',
  bg: 'bg-amber-500/10',
  border: 'border-amber-500/30'
}, {
  id: 3,
  severity: 'TINGGI',
  title: 'Ancaman langsung terhadap kunjungan Presiden',
  context: 'Komentar spesifik menyebut lokasi kunjungan Papua 25 Mei.',
  time: '1 jam lalu',
  icon: ShieldAlert,
  color: 'text-amber-500',
  bg: 'bg-amber-500/10',
  border: 'border-amber-500/30'
}, {
  id: 4,
  severity: 'SEDANG',
  title: 'Sentimen turun 12% pasca-pidato pangan',
  context: 'Didominasi keluhan harga pupuk di wilayah Jawa Tengah.',
  time: '3 jam lalu',
  icon: Info,
  color: 'text-blue-500',
  bg: 'bg-blue-500/10',
  border: 'border-blue-500/30'
}, {
  id: 5,
  severity: 'SEDANG',
  title: 'Akun impersonation @presidenri_official',
  context: 'Ditemukan di X dengan 5.000 followers, menyebar link phishing.',
  time: '4 jam lalu',
  icon: Info,
  color: 'text-blue-500',
  bg: 'bg-blue-500/10',
  border: 'border-blue-500/30'
}];
export function AlertPanel() {
  const [escalateDialog, setEscalateDialog] = useState<{
    open: boolean;
    alert: any;
  }>({
    open: false,
    alert: null
  });
  const handleTindakLanjut = (title: string) => {
    toast.success('Tugas ditambahkan ke Command Tasking', {
      description: `Tindak lanjut untuk: ${title}`
    });
  };
  const handleEscalateSubmit = () => {
    toast.success('Alert berhasil dieskalasi', {
      description: `Notifikasi telah dikirim ke Pimpinan Pengamanan.`
    });
    setEscalateDialog({
      open: false,
      alert: null
    });
  };
  return <>
      <Card className="bg-card border-border/50 h-full flex flex-col" data-id="element-198">
        <CardHeader className="pb-2 pt-4 px-4 border-b border-border/50" data-id="element-199">
          <CardTitle className="font-mono text-xs uppercase tracking-wider text-muted-foreground flex items-center justify-between" data-id="element-200">
            <div className="flex items-center gap-2" data-id="element-201">
              <AlertTriangle className="size-4 text-red-500" data-id="element-202" />
              Alert Prioritas
            </div>
            <span className="bg-red-500 text-white text-[9px] px-1.5 py-0.5 rounded-sm font-bold" data-id="element-203">
              5 BARU
            </span>
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 flex-1 overflow-auto flex flex-col gap-2" data-id="element-204">
          {alerts.map(alert => <div key={alert.id} className={`p-3 rounded-md border ${alert.border} ${alert.bg} flex flex-col gap-2`} data-id="element-205">
              <div className="flex items-start justify-between gap-2" data-id="element-206">
                <div className="flex items-center gap-2" data-id="element-207">
                  <alert.icon className={`size-4 ${alert.color} shrink-0`} data-id="element-208" />
                  <span className={`font-mono text-[9px] font-bold px-1.5 py-0.5 rounded-sm border ${alert.border} ${alert.color}`} data-id="element-209">
                    {alert.severity}
                  </span>
                </div>
                <span className="font-mono text-[9px] text-muted-foreground" data-id="element-210">
                  {alert.time}
                </span>
              </div>

              <div data-id="element-211">
                <h4 className="text-xs font-bold text-foreground leading-tight" data-id="element-212">
                  {alert.title}
                </h4>
                <p className="text-[10px] text-muted-foreground mt-1 leading-snug" data-id="element-213">
                  {alert.context}
                </p>
              </div>

              <div className="flex gap-2 mt-1" data-id="element-214">
                <Button variant="outline" size="xs" className="h-6 text-[9px] font-mono bg-background/50 border-border/50 hover:bg-background" onClick={() => setEscalateDialog({
              open: true,
              alert
            })} data-id="element-215">
                  Eskalasi
                </Button>
                <Button variant="outline" size="xs" className="h-6 text-[9px] font-mono bg-background/50 border-border/50 hover:bg-background" onClick={() => handleTindakLanjut(alert.title)} data-id="element-216">
                  Tindak Lanjut
                </Button>
              </div>
            </div>)}
        </CardContent>
      </Card>

      <Dialog open={escalateDialog.open} onOpenChange={open => !open && setEscalateDialog({
      open: false,
      alert: null
    })} data-id="element-217">
        <DialogContent className="sm:max-w-[425px] border-border/50 bg-background/95 backdrop-blur" data-id="element-218">
          <DialogHeader data-id="element-219">
            <DialogTitle className="font-mono text-sm uppercase tracking-wider text-red-500 flex items-center gap-2" data-id="element-220">
              <AlertTriangle className="size-4" data-id="element-221" />
              Eskalasi Alert
            </DialogTitle>
            <DialogDescription className="text-xs" data-id="element-222">
              Eskalasi alert ini ke tingkat pimpinan atau kementerian terkait.
            </DialogDescription>
          </DialogHeader>

          {escalateDialog.alert && <div className="grid gap-4 py-4" data-id="element-223">
              <div className="rounded-md border border-border/50 bg-muted/20 p-3" data-id="element-224">
                <h4 className="text-xs font-bold text-foreground" data-id="element-225">
                  {escalateDialog.alert.title}
                </h4>
                <p className="text-[10px] text-muted-foreground mt-1" data-id="element-226">
                  {escalateDialog.alert.context}
                </p>
              </div>

              <div className="grid gap-2" data-id="element-227">
                <Label htmlFor="target" className="text-xs" data-id="element-228">
                  Target Eskalasi
                </Label>
                <Select defaultValue="pimpinan" data-id="element-229">
                  <SelectTrigger id="target" className="h-8 text-xs bg-muted/30 border-border/50" data-id="element-230">
                    <SelectValue placeholder="Pilih target" data-id="element-231" />
                  </SelectTrigger>
                  <SelectContent data-id="element-232">
                    <SelectItem value="pimpinan" data-id="element-233">
                      Pimpinan Pengamanan (VVIP)
                    </SelectItem>
                    <SelectItem value="komdigi" data-id="element-234">Kementerian Komdigi</SelectItem>
                    <SelectItem value="polri" data-id="element-235">Bareskrim Polri</SelectItem>
                    <SelectItem value="bin" data-id="element-236">Badan Intelijen Negara</SelectItem>
                  </SelectContent>
                </Select>
              </div>

              <div className="grid gap-2" data-id="element-237">
                <Label htmlFor="note" className="text-xs" data-id="element-238">
                  Catatan Analis
                </Label>
                <Textarea id="note" placeholder="Tambahkan konteks atau rekomendasi tindakan..." className="text-xs bg-muted/30 border-border/50 min-h-[80px]" data-id="element-239" />
              </div>
            </div>}

          <DialogFooter data-id="element-240">
            <Button variant="outline" size="sm" onClick={() => setEscalateDialog({
            open: false,
            alert: null
          })} data-id="element-241">
              Batal
            </Button>
            <Button variant="default" size="sm" className="bg-red-600 hover:bg-red-700 text-white" onClick={handleEscalateSubmit} data-id="element-242">
              <Send className="size-3 mr-2" data-id="element-243" />
              Kirim Eskalasi
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>;
}